import { PairingStatus } from '~/app/enums/PairingStatus';
import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const flowRateTooSlow = (tj: Partial<TherapyJobV2>, deviationPercentage: number) => {
  const isRunning = tj?.status === TherapyJobStatus.RUNNING;
  const notPossibleToMeasure =
    tj?.pairingState === PairingStatus.UN_PAIRED ||
    tj?.pairingState === PairingStatus.IN_PAIRING ||
    !tj?.dripChamberDetected;

  if (!isRunning || notPossibleToMeasure) {
    return false;
  }

  if (deviationPercentage === null || deviationPercentage === undefined) {
    console.warn('No deviation flow rate percentage configured, skipping flow rate check for job: ', tj?.id);
    return false;
  }

  const flowRatePlanned = tj?.flowRatePlannedEdited || tj?.flowRatePlannedPrescribed;
  if (!flowRatePlanned) {
    console.warn('No planned flow rate available, skipping flow rate check for job: ', tj?.id);
    return false;
  }

  const currentFlowRate = tj?.therapyJobProgress?.currentFlowRate;
  if (currentFlowRate === null || currentFlowRate === undefined) {
    return false;
  }

  const flowRateDeviation = flowRatePlanned * (deviationPercentage / 100);
  const isTooSlow = currentFlowRate < flowRatePlanned - flowRateDeviation;

  return isRunning && isTooSlow;
};
